import { getAPIBase } from "@/core/config";

async function otpFetch(path, { csrfToken, method = "GET", body } = {}) {
  const headers = {};
  if (method !== "GET") {
    headers["Content-Type"] = "application/json";
    headers["X-CSRFToken"] = csrfToken;
  }

  const response = await fetch(`${getAPIBase()}${path}`, {
    method,
    credentials: "include",
    headers,
    body: body ? JSON.stringify(body) : undefined
  });

  const data = await response.json().catch(() => null);

  if (!response.ok || data?.ok === false) {
    throw new Error(data?.error || "Something went wrong. Try again.");
  }

  if (!data) {
    throw new Error("Unexpected response from server.");
  }

  return data;
}

export function fetchOtpDevices(csrfToken) {
  return otpFetch("/api/otp/devices/", { csrfToken });
}

export async function fetchOtpSetup(csrfToken) {
  const pending = await otpFetch("/api/otp/setup/", { csrfToken });
  if (pending.qrDataUri) {
    return pending;
  }

  return otpFetch("/api/otp/setup/", {
    csrfToken,
    method: "POST",
    body: {}
  });
}

export function startOtpReplacement(csrfToken, currentToken) {
  return otpFetch("/api/otp/setup/", {
    csrfToken,
    method: "POST",
    body: { currentToken }
  });
}

export function verifyOtpSetup(csrfToken, token) {
  return otpFetch("/api/otp/setup/verify/", {
    csrfToken,
    method: "POST",
    body: { token }
  });
}

export function verifyOtpSession(csrfToken, { token, remember }) {
  return otpFetch("/api/otp/verify/session/", {
    csrfToken,
    method: "POST",
    body: { token, remember }
  });
}

export async function logOutViaFetch(csrfToken) {
  await fetch(`${getAPIBase()}/api/graphql/`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-CSRFToken": csrfToken
    },
    body: JSON.stringify({
      query: "mutation { logOutMutation { result } }"
    })
  });
}

export function needsOtpAction(otp) {
  if (!otp) return null;
  if (otp.setupRequired) return "setup";
  if (otp.hasDevice && !otp.verified) return "verify";
  return null;
}
